import React, { useState, useEffect } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import IntroSection from './components/IntroSection';
import AboutSection from './components/AboutSection';
import EventsSection from './components/EventsSection';
import CoursesSection from './components/CoursesSection';
import ProfessorsSection from './components/ProfessorsSection';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';

function App() {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 400);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <div className="App">
      <Navbar />
      
      <main>
        <div id="home">
          <Hero />
        </div>
        <div id="about">
          <AboutSection />
        </div>
        <div id="intro">
          <IntroSection />
        </div>
        <div id="solutions">
          <EventsSection />
        </div>
        <div id="training">
          <CoursesSection />
        </div>
        
        <div id="team">
          <ProfessorsSection />
        </div>
        <div id="contact">
          <ContactForm />
        </div>
      </main>
      
      <Footer />
      
      {/* Scroll to Top Button */}
      {showScrollTop && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-8 right-8 z-50 w-14 h-14 bg-gradient-to-r from-brand-primary via-brand-secondary to-brand-dark text-white rounded-full shadow-2xl hover:shadow-3xl transition-all duration-300 transform hover:scale-110 hover:from-brand-secondary hover:via-brand-dark hover:to-brand-dark animate-fadeIn"
          aria-label="Scroll to top"
        >
          <svg className="w-6 h-6 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
          </svg>
        </button>
      )}
    </div>
  );
}

export default App;
